import { Reveal } from "@/components/Reveal";

export default function SectionHead({ eyebrow, title, sub, align = "start", testid = "section-head" }) {
  const alignCls = align === "center" ? "text-center items-center mx-auto" : "text-start";
  return (
    <Reveal className={`flex flex-col ${alignCls} max-w-3xl mb-12 md:mb-16`} data-testid={testid}>
      <p className="eyebrow mb-4">{eyebrow}</p>
      <h2 className="font-head text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">{title}</h2>
      {sub && <p className="mt-5 text-muted-foreground text-base sm:text-lg leading-relaxed">{sub}</p>}
    </Reveal>
  );
}
